import styled from 'styled-components'
import { blue } from '../../color'

export const ExplorerToolbar = styled.div`
  background: #ffffff;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
`

export const CommandBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  padding: 4px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;

  .ant-btn-text {
    font-size: 13px;
    font-weight: 500;
    color: #555;
    height: 32px;
    padding: 0 12px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
      background-color: #f5f5f5 !important;
      color: ${blue};
    }

    .anticon {
      font-size: 14px;
    }
  }
`

export const AddressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: #fff;
`

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const NavButton = styled.button`
  border: none;
  background: transparent;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  color: ${p => (p.disabled ? '#bfbfbf' : '#555')};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #f0f2f5;
    color: ${blue};
  }

  span {
    font-size: 16px;
  }
`

export const AddressBar = styled.div`
  flex: 1;
  background: #fdfdfd;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  gap: 0;
  overflow: hidden;
  transition: all 0.2s;
  box-sizing: border-box;

  &:hover {
    border-color: #d0d0d0;
    background: #fff;
  }

  &:focus-within {
    border-color: #d0d0d0;
    background: #fff;
  }

  .address-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #555;
    cursor: pointer;
    white-space: nowrap;
    padding: 0 8px;
    height: 100%;
    border-radius: 4px;

    &:hover {
      background: #f0f0f0;
      color: ${blue};
    }
  }

  .separator {
    margin: 0;
    color: #ccc;
    font-size: 11px;
    user-select: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 4px;
  }
`

export const SearchBox = styled.div`
  width: 300px;
  height: 32px;
  background: #fdfdfd;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  box-sizing: border-box;
  overflow: hidden;

  &:hover {
    border-color: #d0d0d0;
    background: #fff;
  }

  &:focus-within {
    border-color: #d0d0d0;
    background: #fff;
  }

  .ant-input-search {
    width: 100%;
    
    // Deep clean all internal wrappers
    &.ant-input-group-wrapper,
    .ant-input-group-wrapper,
    .ant-input-wrapper,
    .ant-input-group,
    .ant-input-affix-wrapper {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
      padding: 0 !important;
      height: 30px !important;
    }

    .ant-input {
      height: 30px !important;
      border: none !important;
      background: transparent !important;
      font-size: 13px;
      padding-right: 32px;
      padding-left: 12px;
      box-shadow: none !important;
      outline: none !important;

      &:focus {
        box-shadow: none !important;
        border: none !important;
      }
    }

    .ant-input-suffix {
      right: 12px;
      color: #999;
      font-size: 13px;
      display: flex;
      align-items: center;
    }

    .ant-input-group-addon {
      display: none !important;
    }
  }
`

export const FileTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bfbfbf;
  }
`

export const FileTable = styled.table`
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  font-size: 14px;

  thead tr {
    border-bottom: 2px solid #f0f0f0;
  }

  thead th {
    padding: 10px 12px;
    text-align: left;
    color: #8c8c8c;
    font-weight: 600;
    font-size: 13px;
    white-space: nowrap;
    border-bottom: 1px solid #f0f0f0;
  }

  tbody tr {
    border-bottom: 1px solid #f5f5f5;
    transition: all 0.2s;
    cursor: default;
  }

  tbody tr:hover {
    background: #f9f9f9;
  }

  tbody td {
    padding: 10px 12px;
    vertical-align: middle;
  }
`

export const SortableHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;

  &:hover {
    color: ${blue};
  }
`

export const SortIcon = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: ${p => (p.active ? blue : '#bfbfbf')};

  .active {
    color: ${blue};
  }
`

export const NameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  width: 100%;

  /* Override FileItem's internal wrapping */
  div,
  span {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: keep-all !important;
  }

  .file-item {
    display: inline-block;
    max-width: 100%;
  }

  .doc-name {
    font-weight: 500;
    color: #222;
    cursor: ${p => (p.isFolder ? 'pointer' : 'default')};
    flex: 1;
    min-width: 0;

    &:hover {
      color: ${p => (p.isFolder ? blue : '#222')};
    }
  }
`

export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.15s;

  tr:hover & {
    opacity: 1;
  }
`

export const ActionBtn = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  color: #666;
  display: flex;
  align-items: center;
  font-size: 15px;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f0f0f0;
    color: ${p => (p.danger ? '#ff4d4f' : blue)};
  }
`

export const DateText = styled.span`
  color: #999;
  font-size: 13px;
  white-space: nowrap;
`

export const EmptyWrap = styled.div`
  padding: 48px;
  text-align: center;
`

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 24px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f0f0;
`

export const InlineInput = styled.input`
  flex: 1;
  min-width: 0;
  border: 1px solid #1890ff;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 14px;
  font-weight: 500;
  color: #222;
  outline: none;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.15);

  &:focus {
    border-color: #40a9ff;
  }
`

export const DragHandle = styled.button`
  border: none;
  background: transparent;
  cursor: grab;
  padding: 4px 6px;
  border-radius: 4px;
  color: #aaa;
  display: flex;
  align-items: center;
  font-size: 15px;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f0f0f0;
    color: #1890ff;
  }

  &:active {
    cursor: grabbing;
  }
`
